import actionList from '@/libs/acl_roles/actionList'
import rolesPermission from '@/libs/acl_roles/rolesPermission'

const { ACTION_VIEW } = actionList
const { SITE_BACKUPS } = rolesPermission

export default [
  {
    path: '/site/:id/hardware/backups/:backupId',
    name: 'site-summary-backup-details',
    component: () => import('@/views/apps/site-backups/Show.vue'),
    meta: {
      resource: SITE_BACKUPS,
      action: ACTION_VIEW,
      navActiveLink: 'sites-list',
      pageTitle: 'Backup Details',
      breadcrumb: [
        {
          text: 'List',
          to: '/sites/list',
        },
        {
          text: 'Backup Details',
          active: true,
        },
      ],
    },
  },
]
